module.exports = __webpack_public_path__ + "img/func_banner_img.9fbaa3fa.png";